import { useState } from "react";
import { Check, ChevronDown, ChevronUp, Eye } from "lucide-react";

export const READER_VIEWS = [
  { id: "admin", label: "Ma vue (admin)" },
  { id: "guest", label: "Visiteur non connecté" },
  { id: "free", label: "Membre gratuit" },
  { id: "subscriber", label: "Abonné (toutes offres)" },
];

// Vues proposées sur la page Outils : l'accès dépend de l'offre exacte (Essentiel ou Pro).
export const TOOL_VIEWS = [
  { id: "admin", label: "Ma vue (admin)" },
  { id: "guest", label: "Visiteur non connecté" },
  { id: "free", label: "Membre gratuit" },
  { id: "essentiel", label: "Abonné Essentiel" },
  { id: "pro", label: "Abonné Pro" },
];

// Vues proposées sur les pages Portefeuilles (accès strict par offre, jusqu'à Max)
export const PORTFOLIO_VIEWS = [
  { id: "admin", label: "Ma vue (admin)" },
  { id: "guest", label: "Visiteur non connecté" },
  { id: "free", label: "Membre gratuit" },
  { id: "essentiel", label: "Abonné Essentiel" },
  { id: "pro", label: "Abonné Pro" },
  { id: "max", label: "Abonné Max" },
];

// Page Offres : mêmes lecteurs que les portefeuilles
export const OFFER_VIEWS = PORTFOLIO_VIEWS;

// Page Mon compte : pas de visiteur (page réservée aux connectés), + un abonné résilié
export const ACCOUNT_VIEWS = [
  { id: "admin", label: "Ma vue (admin)" },
  { id: "free", label: "Membre gratuit" },
  { id: "essentiel", label: "Abonné Essentiel" },
  { id: "pro", label: "Abonné Pro" },
  { id: "max", label: "Abonné Max" },
  { id: "canceled", label: "Abonné Pro (résilié)" },
];

export const readerViewLabel = (id, views = READER_VIEWS) => views.find((v) => v.id === id)?.label || "";

/**
 * Panneau flottant « Vue du lecteur » — à n'afficher QUE pour un compte admin.
 * Permet de prévisualiser une page telle que la voit chaque type de lecteur.
 * `views` : liste des vues proposées (READER_VIEWS par défaut, TOOL_VIEWS sur la page Outils, PORTFOLIO_VIEWS sur les Portefeuilles, OFFER_VIEWS et ACCOUNT_VIEWS sur Offres et Mon compte).
 */
export default function AdminReaderPreview({ value, onChange, views = READER_VIEWS }) {
  // Téléphone : fermé au départ (petit bouton au-dessus de la barre du bas) pour ne pas cacher la page
  const [open, setOpen] = useState(() => typeof window === "undefined" || window.innerWidth >= 768);
  return (
    <div
      className={`fixed right-4 bottom-20 md:bottom-4 z-40 rounded-xl border border-violet-500/30 bg-card/95 backdrop-blur shadow-2xl ${open ? "w-64" : "w-auto md:w-64"}`}
      data-testid="admin-reader-preview"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left"
      >
        <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-violet-300">
          <Eye className="w-3.5 h-3.5" /> Vue du lecteur<span className={open ? "" : "hidden md:inline"}> · admin</span>
        </span>
        {open ? <ChevronDown className="w-4 h-4 text-zinc-500" /> : <ChevronUp className="w-4 h-4 text-zinc-500" />}
      </button>
      {open && (
        <div className="px-3 pb-3">
          <div className="grid gap-1">
            {views.map((v) => (
              <button
                type="button"
                key={v.id}
                onClick={() => onChange(v.id)}
                data-testid={`reader-view-${v.id}`}
                className={`flex items-center justify-between gap-2 w-full rounded-md px-3 py-2 text-sm text-left transition-colors ${
                  value === v.id ? "bg-violet-500/15 text-white" : "text-zinc-400 hover:bg-white/5 hover:text-zinc-200"
                }`}
              >
                <span>{v.label}</span>
                {value === v.id && <Check className="w-4 h-4 text-violet-300" />}
              </button>
            ))}
          </div>
          <p className="mt-3 px-1 text-[11px] leading-relaxed text-zinc-500">
            Simule ce que voit chaque lecteur. Ne change rien à votre compte et n'est visible que par les admins.
          </p>
        </div>
      )}
    </div>
  );
}
